import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedGengiSkraningReq } from 'app/interfaces/requests/Exposed/exposedGengiSkraningReq';
import { ListKriaDagsuppgjorReq } from 'app/interfaces/requests/List/listKriaDagsuppgjorReq';
import { ListMarketValueOverviewDivisionReq } from 'app/interfaces/requests/List/listMarketValueOverviewDivisionReq';
import { ReadKriaSidastaGengiReq } from 'app/interfaces/requests/Read/readKriaSidastaGengiReq';
import { ReadKriaSkradGengiReq } from 'app/interfaces/requests/Read/readKriaSkradGengiReq';
import { ReadMarketValueDivisionReq } from 'app/interfaces/requests/Read/readMarketValueDivisionReq';
import { ListKriaDagsuppgjorRes } from 'app/interfaces/responses/List/listKriaDagsuppgjorRes';
import { ListMarketValueOverviewDivisionRes } from 'app/interfaces/responses/List/listMarketValueOverviewDivisionRes';
import { ReadKriaSidastaGengiRes } from 'app/interfaces/responses/Read/readKriaSidastaGengiRes';
import { ReadKriaSkradGengiRes } from 'app/interfaces/responses/Read/readKriaSkradGengiRes';
import { ReadMarketValuePortfolioRes } from 'app/interfaces/responses/Read/readMarketValuePortfolioRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GengiService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public kriaDagsuppgjor(
        req: ListKriaDagsuppgjorReq,
        showError = true,
        showLoader = true,
        loadingMessage = 'Sæki gengi'
    ): Observable<Array<ListKriaDagsuppgjorRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(loadingMessage);

        let subject = new Subject<Array<ListKriaDagsuppgjorRes>>();
        this.http
            .post(environment.localApi + 'gengi/kriaDagsuppgjor', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListKriaDagsuppgjorRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public kriaSkradGengi(req: ReadKriaSkradGengiReq, showError = true): Observable<ReadKriaSkradGengiRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Hleð gögnum');

        let subject = new Subject<ReadKriaSkradGengiRes>();
        this.http
            .post(environment.localApi + 'gengi/KriaSkradGengi', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ReadKriaSkradGengiRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    subject.next(null);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public SkraGengi(req: ExposedGengiSkraningReq, showError = true): Observable<null> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Skrái gengi');

        let subject = new Subject<null>();
        this.http
            .post(environment.localApi + 'gengi/SkraGengi', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<null>) => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Gengi hefur verið skráð');
                    this.alertsService.changeAlertSuccessShow(true);
                    subject.next(null);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public kriaSidastaGengi(req: ReadKriaSidastaGengiReq, showError = true): Observable<ReadKriaSidastaGengiRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Hleð gögnum');

        let subject = new Subject<ReadKriaSidastaGengiRes>();
        this.http
            .post(environment.localApi + 'gengi/kriaSidastaGengi', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ReadKriaSidastaGengiRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listMarketValueOverviewDivision(
        req: ListMarketValueOverviewDivisionReq,
        showError = true
    ): Observable<Array<ListMarketValueOverviewDivisionRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki markaðsverð');

        let subject = new Subject<Array<ListMarketValueOverviewDivisionRes>>();
        this.http
            .post(environment.localApi + 'gengi/listMarketValueOverviewDivision', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ListMarketValueOverviewDivisionRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public markadsvirdiLeidar(req: ReadMarketValueDivisionReq, showError = true): Observable<ReadMarketValuePortfolioRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki gengi');

        let subject = new Subject<ReadMarketValuePortfolioRes>();
        this.http
            .post(environment.localApi + 'gengi/markadsvirdiLeidar', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ReadMarketValuePortfolioRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }
}
